import { ProfileDestination } from '~/models/ProfileDestination'
import Calendar from '../shared/calendar'
import { ApiProfile, ApiProfileDestination } from './apiTypes'
import { Profile } from '~/models/Profile'

export default class ProfileApiMapper {
	public static toApiAvailability(username: string): string {
		return username.toLocaleLowerCase()
	}

	public static toApiUpdateProfile(profile: Profile): FormData {
		const result = {
			username: profile.username,
			name: profile.name,
			country_id: profile.country,
			birth_date: profile.birthYear && Calendar.getFirstDateOf(profile.birthYear),
			picture_id: profile.avatarId,
			cover_id: profile.coverId,
			consent_commercial_communications: profile.consentCommercialCommunications?.toString(),
		} as ApiProfile
		return this.toFormData(result)
	}

	public static toFormData(profile: ApiProfile): FormData {
		const formData = new FormData()
		Object.entries(profile).forEach(([key, value]) => {
			if (value) formData.append(key, value)
		})
		return formData
	}

	public static toProfileDestinations(destinations: ProfileDestination[]): ApiProfileDestination[] {
		return destinations.map((destination) => ({
			destination_id: destination.destinationId,
			state: destination.type!,
		}))
	}
}
